export default __webpack_public_path__ + "assets/mining_the_skies.498e6369.png";